import type { SVGProps } from "react";
export const Trash2Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    className="fill-current"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.455 6.91v-.728A2.18 2.18 0 0 1 10.637 4h2.909a2.18 2.18 0 0 1 2.181 2.182v.727h2.91a.727.727 0 1 1 0 1.455h-.728v9.454A2.18 2.18 0 0 1 15.727 20H8.455a2.18 2.18 0 0 1-2.182-2.182V8.364h-.727a.727.727 0 0 1 0-1.455zm1.667-1.242a.73.73 0 0 1 .515-.213h2.909a.727.727 0 0 1 .727.727v.727H9.909v-.727c0-.193.077-.378.213-.514M7.727 8.364h8.728v9.454a.727.727 0 0 1-.728.727H8.455a.727.727 0 0 1-.728-.727z"
      clipRule="evenodd"
    />
  </svg>
);
